import { render, staticRenderFns } from "./CostAlarmTable.vue?vue&type=template&id=3924463b"
import script from "./CostAlarmTable.vue?vue&type=script&lang=js"
export * from "./CostAlarmTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports